import { useState } from 'react'
import { cn } from '@/lib/utils'
import {
  KnowledgeDialog,
  KnowledgePanel,
} from '@/features/editor/components/knowledge'
import { EDITOR_QUICK_GUIDE_URL } from '@/features/editor/lib/manual'
import { useEditorStore } from '@/features/editor/stores/editor-store'
import { SectionCard } from './section-card'

function formatStatus(enabled: number, total: number) {
  if (total <= 0) return '未创建'
  return `启用 ${enabled} / ${total}`
}

export function KnowledgeSection() {
  const worldCount = useEditorStore((s) => s.knowledge.worldInfo.length)
  const worldEnabled = useEditorStore(
    (s) => s.knowledge.worldInfo.filter((e) => e.enabled).length
  )
  const charCount = useEditorStore((s) => s.knowledge.characterProfiles.length)
  const charEnabled = useEditorStore(
    (s) => s.knowledge.characterProfiles.filter((e) => e.enabled).length
  )

  const [openWorld, setOpenWorld] = useState(false)
  const [openChars, setOpenChars] = useState(false)

  return (
    <SectionCard
      title='世界背景设定'
      description={
        <div className='space-y-1'>
          <div>
            世界信息与角色档案会在对话中作为可检索知识被引用，强烈建议您依照
            <a
              href={EDITOR_QUICK_GUIDE_URL}
              target='_blank'
              rel='noreferrer'
              className='text-primary underline-offset-4 hover:underline'
            >
              “快速指引”
            </a>
            中的模板快速编写。
          </div>
          <div>严禁使用你、我、他、她、它等人称代词单数或复数作为关键词。</div>
          <div>您必须填写“关键词”，如未填写，AI将无法检索相应的条目。</div>
          <div>您需要填写高密度信息，用最准确与精炼的语言定义您的世界。</div>
        </div>
      }
    >
      {/* 入口卡片 */}
      <div className='grid gap-3 md:grid-cols-2'>
        {/* 世界信息 */}
        <button
          type='button'
          onClick={() => setOpenWorld(true)}
          className={cn(
            'border-border bg-background rounded-2xl border p-4 text-left',
            'transition',
            'hover:bg-muted/20 hover:shadow-sm',
            'focus-visible:ring-ring/30 focus-visible:ring-2 focus-visible:outline-none'
          )}
        >
          <div className='flex items-center justify-between gap-3'>
            <div className='text-sm font-medium'>世界信息</div>
            <div className='text-muted-foreground text-xs'>
              {formatStatus(worldEnabled, worldCount)}
            </div>
          </div>
          <div className='text-muted-foreground mt-1 text-sm leading-5'>
            用于世界观、规则、地点、组织等设定。
          </div>
        </button>

        {/* 角色档案 */}
        <button
          type='button'
          onClick={() => setOpenChars(true)}
          className={cn(
            'border-border bg-background rounded-2xl border p-4 text-left',
            'transition',
            'hover:bg-muted/20 hover:shadow-sm',
            'focus-visible:ring-ring/30 focus-visible:ring-2 focus-visible:outline-none'
          )}
        >
          <div className='flex items-center justify-between gap-3'>
            <div className='text-sm font-medium'>角色档案</div>
            <div className='text-muted-foreground text-xs'>
              {formatStatus(charEnabled, charCount)}
            </div>
          </div>
          <div className='text-muted-foreground mt-1 text-sm leading-5'>
            用于角色性格、人设、关系、禁忌等设定。
          </div>
        </button>
      </div>

      {/* 世界信息编辑 */}
      <KnowledgeDialog
        open={openWorld}
        title='世界信息'
        onClose={() => setOpenWorld(false)}
      >
        <KnowledgePanel kind='worldInfo' />
      </KnowledgeDialog>

      {/* 角色档案编辑 */}
      <KnowledgeDialog
        open={openChars}
        title='角色档案'
        onClose={() => setOpenChars(false)}
      >
        <KnowledgePanel kind='characterProfiles' />
      </KnowledgeDialog>
    </SectionCard>
  )
}
